import { Link } from 'react-router-dom';

import { STATE_LABEL } from '@/data/products';
import { fmtAMD } from '@/lib/format';
import ImgSlot from '@/ui/ImgSlot';
import type { Product } from '@/types';

import styles from './ProductCard.module.css';

interface ProductCardProps {
  p: Product;
  idx: number;
}

function stockSummary(p: Product): string {
  return Object.entries(p.sizes)
    .filter(([, v]) => v != null)
    .map(([k]) => k)
    .join(' / ');
}

function addLabelFor(state: Product['state']): string {
  if (state === 'soldout') return 'WAITLIST';
  if (state === 'archived') return 'VIEW';
  if (state === 'coming') return 'NOTIFY';
  return 'ADD';
}

export default function ProductCard({ p, idx }: ProductCardProps) {
  const fabricPrimary = p.fabric.split(' / ')[0] ?? '';
  const addLabel = addLabelFor(p.state);

  return (
    <Link to={`/shop/${p.id}`} className={styles.root} data-state={p.state} aria-label={p.name}>
      <div className={styles.img}>
        <ImgSlot label={`${p.type} · ${p.color}`} />
        <span className={`${styles.corner} ${styles.cornerTl}`}>
          /{String(idx).padStart(3, '0')}
        </span>
        <span className={`${styles.corner} ${styles.cornerTr}`}>{p.code}</span>
        <span className={styles.stamp}>{STATE_LABEL[p.state]}</span>
        <div className={styles.hoverMeta}>
          <span>{stockSummary(p)}</span>
          <span>{fabricPrimary}</span>
        </div>
      </div>
      <div className={styles.info}>
        <span className={styles.name}>{p.name}</span>
        <span className={styles.code}>{p.code}</span>
        <span className={styles.meta}>
          {p.color} · {p.drop}
        </span>
        <span className={styles.price}>{fmtAMD(p.price)}</span>
        <span className={styles.add}>{addLabel}</span>
      </div>
    </Link>
  );
}
